// Hooks
import { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';

// Next
import Image from 'next/image';

// GSAP
import { gsap, Power2 } from 'gsap';

// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS, imageLoader } from '../../helpers/contentful';

const timeline = gsap.timeline();

const Benefits = (props) => {
  const { title, description, figure, items } = props;

  // ref to BenefitsText
  const refBenefitsText = useRef();

  // store
  const [benefitLines, setBenefitLines] = useState('');
  const benefitsTextInnerHTML = { __html: benefitLines };

  // intersection observer
  const [refBenefitsTextContainer, inView] = useInView({
    rootMargin: '0px 0px -200px 0px',
    triggerOnce: true,
  });

  useEffect(() => {
    let html = '';
    items.map((item) => {
      let line = '<div class="Benefits-item">';
      item.text.content.map((node) => {
        const string = node.content[0].value;
        line += `<p>${string}</p>`;
        return true;
      });
      line += '</div>';

      html += line;
      return true;
    });

    setBenefitLines(html);
  }, [items]);

  useEffect(() => {
    if (inView) {
      const lines = refBenefitsText.current.querySelectorAll('.Benefits-item');
      refBenefitsText.current.style.opacity = 1;
      timeline.from(lines, { duration: 0.8, delay: 0.1, color: '#D0CFC6', ease: Power2.easeOut, stagger: 0.7 });
    }
  }, [inView]);

  useEffect(
    () => () => {
      timeline.clear();
    },
    [],
  );

  return (
    <div className="Benefits">
      <div className="Benefits-inner">
        <div className="Benefits-wrapper">
          {figure && (
            <div className="Benefits-figure">
              {figure.src && (
                <div className="Benefits-image">
                  <div className="Benefits-imageWrap">
                    <Image
                      lazyBoundary="500px"
                      layout="responsive"
                      sizes="(min-width: 1440px) 1280px, 100vw"
                      loader={imageLoader}
                      src={`https:${figure.src}`}
                      alt={figure.alt}
                      height={figure.height}
                      width={figure.width}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
          {(title || description) && (
            <div className="Benefits-header">
              {title && (
                <h2 className="Benefits-title">{[documentToReactComponents(title, RENDER_DOCUMENT_OPTIONS)]}</h2>
              )}
              {description && (
                <div className="Benefits-description">
                  {[documentToReactComponents(description, RENDER_DOCUMENT_OPTIONS)]}
                </div>
              )}
            </div>
          )}
          <div className="Benefits-values" ref={refBenefitsTextContainer}>
            <div className="Benefits-items" ref={refBenefitsText} dangerouslySetInnerHTML={benefitsTextInnerHTML} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
